import { Trans } from '@lingui/react'
import {
  type NowMerchantExtended,
  type NowSlot,
} from '@redteclab/api/clients/bully'
import classNames from 'classnames'
import { type Dispatch, type ReactElement, type SetStateAction } from 'react'

import Button from 'views/components/atoms/Button'
import InputTextWithFloatingLabel from 'views/components/molecules/InputTextWithFloatingLabel'
import NowDeliveryBox from 'views/components/organisms/NowShippingModal/NowShippingModalContent/NowDeliveryBox'
import {
  NOT_IN_DELIVERY_REGION,
  PRODUCTS_NOT_AVAILABLE,
} from 'views/consts/notEligibleReasons'

import 'views/components/organisms/NowShippingModal/NowShippingModal.scss'

export interface INowSlotExtended extends NowSlot {
  shippingCostsAmountSpecial: number
  shippingCostsAmountDefault: number
}

export interface INowDeliveryBoxData {
  slot: INowSlotExtended
  merchant: NowMerchantExtended
}

interface INowZipForm {
  nowEligible: boolean
  notEligibleReasonCode?: number
  zipCode: string
  setZipCode: Dispatch<SetStateAction<string>>
  handleSubmit: () => void
  nowDeliveryBoxData: INowDeliveryBoxData | null
}

const NowZipForm: (props: INowZipForm) => ReactElement = ({
  nowEligible,
  notEligibleReasonCode,
  zipCode,
  setZipCode,
  handleSubmit,
  nowDeliveryBoxData,
}) => {
  return (
    <div>
      <p>
        <Trans id="general.label.now.description" />
      </p>
      <div
        className={classNames('o-NowShippingWrapper', {
          'o-nowEligible': nowEligible,
          'o-nowNotEligible': !!notEligibleReasonCode,
        })}
      >
        <h3>
          <Trans id="general.label.now.checkAvailability" />
        </h3>
        <div className="l-flex l-flex__column l-flex__row@medium">
          <div className="o-NowInput">
            <InputTextWithFloatingLabel
              defaultValue={zipCode}
              onChange={e => setZipCode(e.target.value)}
              name="pzn-input"
              inputType="text"
            >
              <Trans id="general.label.now.zipcode" />
            </InputTextWithFloatingLabel>
          </div>

          <Button
            type="button"
            name="btnConfirm"
            className="o-NowButtonMargin"
            onClick={handleSubmit}
            style="buttonPrimary"
          >
            <Trans id="general.label.now.checkNow" />
          </Button>
        </div>
        {!!notEligibleReasonCode && (
          <ul className="o-nowUlInformation">
            <li className="o-nowLiColor">
              {notEligibleReasonCode === NOT_IN_DELIVERY_REGION && (
                <Trans id="general.label.now.zipNotAvailable" />
              )}
              {notEligibleReasonCode >= PRODUCTS_NOT_AVAILABLE && (
                <Trans id="general.label.now.productNotAvailable" />
              )}
            </li>
          </ul>
        )}
        {nowEligible && (
          <ul className="o-nowUlInformation o-nowEligibleTextColor">
            <li className="o-nowEligibleLiColor o-nowEligibleTextColor">
              <Trans id="general.label.now.zipAvailable" />
            </li>
          </ul>
        )}
      </div>
      {nowEligible && (
        <NowDeliveryBox
          deliveryDay={nowDeliveryBoxData?.slot?.deliveryDay}
          minimumOrder={nowDeliveryBoxData?.merchant?.minimumOrderValue}
          deliveryCost={nowDeliveryBoxData?.slot?.shippingCostsAmountDefault}
          deliveryRedpoints={
            nowDeliveryBoxData?.slot?.shippingCostsAmountSpecial
          }
          secondsLeft={nowDeliveryBoxData?.slot?.secondsLeft}
          carrierName={nowDeliveryBoxData?.merchant?.merchantName}
          deliveryTimeInfo={nowDeliveryBoxData?.slot?.deliveryTimeInfo}
        />
      )}
    </div>
  )
}

export default NowZipForm
